import { render, staticRenderFns } from "./domain-card.vue?vue&type=template&id=75236412&scoped=true&"
import script from "./domain-card.ts?vue&type=script&lang=ts&"
export * from "./domain-card.ts?vue&type=script&lang=ts&"
import style0 from "./domain-card.scss?vue&type=style&index=0&id=75236412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75236412",
  null
  
)

export default component.exports